<script>
import { defineComponent } from 'vue'
import { useFundraiserStore } from '@/stores/fundraiser.js'
import TwListGroup from '@/components/generic/list-group/tw-list-group.vue'
import TwListGroupItem from '@/components/generic/list-group/tw-list-group-item.vue'
import TwBadge from '@/components/generic/tw-badge.vue'
import TwButton from '@/components/generic/tw-button.vue'
import WebconnexIntegrationListGroupItem from '@/components/webconnex-integration/webconnex-integration-list-group-item.vue'
import fetchItemsMixin from '@/mixins/fetchItemsMixin.js'
import { useItemsStore } from '@/stores/items.js'
import { useWebconnexIntegrationStore } from '@/stores/webconnexIntegration.js'
import TwLoadingSpinner from '@/components/generic/tw-loading-spinner.vue'

export default defineComponent({
  name: 'FundraiserWebConnexIntegrationPage',
  components: { TwLoadingSpinner, WebconnexIntegrationListGroupItem, TwListGroup },
  mixins:[fetchItemsMixin],
  props: {
    fundraiserId: {
      type: Number,
      default: null
    }
  },
  computed: {
    fundraiser() {
      return useFundraiserStore().getItemById(this.fundraiserId)
    },
    itemsStoreModule () {
      return useWebconnexIntegrationStore()
    },
  },
  mounted() {
    this.fetchItems({
      fundraiser_id: this.fundraiserId,
    })
  },
  methods: {
  }
})
</script>

<template>
  <div>
    <h2>Integrate with RedPodium</h2>
    <div>
      Here you have a list of triggers currently setup from your RedPodium Event account.
    </div>

    <tw-loading-spinner v-if="LoadingFetchingItems" />
    <tw-list-group v-else>
      <webconnex-integration-list-group-item v-for="webConnexIntegration in items" :key="`hook-${webConnexIntegration.id}`" :webconnex-integration="webConnexIntegration" :fundraiser="fundraiser" />
    </tw-list-group>
  </div>
</template>

<style scoped>

</style>
